var _circle, _circle2, _circle3, _circle4, _circle5, _circle6, _circle7, _circle8, _circle9;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLandingHeaderBg(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1341,
    height: 679,
    viewBox: "0 0 1341 679",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.1,
    cx: 184,
    cy: 141,
    r: 263,
    stroke: "#6587FA",
    strokeWidth: 2
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.1,
    cx: 91,
    cy: -13,
    r: 159,
    fill: "#6587FA"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.1,
    cx: 999,
    cy: 355,
    r: 159,
    fill: "#6587FA"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.1,
    cx: 799,
    cy: 473,
    r: 13,
    stroke: "#6587FA",
    strokeWidth: 2
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.1,
    cx: 383,
    cy: 531,
    r: 13,
    stroke: "#6587FA",
    strokeWidth: 2
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.1,
    cx: 1113,
    cy: 451,
    r: 227,
    stroke: "#6587FA",
    strokeWidth: 2
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.05,
    cx: 1188,
    cy: 422,
    r: 125,
    fill: "#6587FA"
  })), _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.2,
    cx: 331,
    cy: 575,
    r: 29,
    stroke: "#6587FA",
    strokeWidth: 2
  })), _circle9 || (_circle9 = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.1,
    cx: 281,
    cy: 610,
    r: 50,
    fill: "#6587FA"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLandingHeaderBg);
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTM0MSIgaGVpZ2h0PSI2NzkiIHZpZXdCb3g9IjAgMCAxMzQxIDY3OSIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KICAgIDxjaXJjbGUgb3BhY2l0eT0iMC4xIiBjeD0iMTg0IiBjeT0iMTQxIiByPSIyNjMiIHN0cm9rZT0iIzY1ODdGQSIgc3Ryb2tlLXdpZHRoPSIyIi8+CiAgICA8Y2lyY2xlIG9wYWNpdHk9IjAuMSIgY3g9IjkxIiBjeT0iLTEzIiByPSIxNTkiIGZpbGw9IiM2NTg3RkEiLz4KICAgIDxjaXJjbGUgb3BhY2l0eT0iMC4xIiBjeD0iOTk5IiBjeT0iMzU1IiByPSIxNTkiIGZpbGw9IiM2NTg3RkEiLz4KICAgIDxjaXJjbGUgb3BhY2l0eT0iMC4xIiBjeD0iNzk5IiBjeT0iNDczIiByPSIxMyIgc3Ryb2tlPSIjNjU4N0ZBIiBzdHJva2Utd2lkdGg9IjIiLz4KICAgIDxjaXJjbGUgb3BhY2l0eT0iMC4xIiBjeD0iMzgzIiBjeT0iNTMxIiByPSIxMyIgc3Ryb2tlPSIjNjU4N0ZBIiBzdHJva2Utd2lkdGg9IjIiLz4KICAgIDxjaXJjbGUgb3BhY2l0eT0iMC4xIiBjeD0iMTExMyIgY3k9IjQ1MSIgcj0iMjI3IiBzdHJva2U9IiM2NTg3RkEiIHN0cm9rZS13aWR0aD0iMiIvPgogICAgPGNpcmNsZSBvcGFjaXR5PSIwLjA1IiBjeD0iMTE4OCIgY3k9IjQyMiIgcj0iMTI1IiBmaWxsPSIjNjU4N0ZBIi8+CiAgICA8Y2lyY2xlIG9wYWNpdHk9IjAuMiIgY3g9IjMzMSIgY3k9IjU3NSIgcj0iMjkiIHN0cm9rZT0iIzY1ODdGQSIgc3Ryb2tlLXdpZHRoPSIyIi8+CiAgICA8Y2lyY2xlIG9wYWNpdHk9IjAuMSIgY3g9IjI4MSIgY3k9IjYxMCIgcj0iNTAiIGZpbGw9IiM2NTg3RkEiLz4KPC9zdmc+Cg==";
export { ForwardRef as ReactComponent };